import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bfa4453"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-map-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title" }, "客户分布", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "map-home" }, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { onMounted } from 'vue'
import { createMap } from '@/utils/map.utils'
import { CODE_ENUM, MAP_TYPE_ENUM } from '@/common'
import { queryTenantLocationList } from '@/api'
import L from 'leaflet'


export default /*#__PURE__*/_defineComponent({
  __name: 'customer-map',
  setup(__props) {

let map: any = null
onMounted(() => {
  map = createMap('map-home', {
    tileLayerType: MAP_TYPE_ENUM.STAND,
  })
  queryLocation()
})

const queryLocation = async () => {
  const res: any = await queryTenantLocationList()
  if (res?.code === CODE_ENUM.SUCCESS) {
    const data = (res.data || []).reduce((mo: any, el: any) => {
      const { locationLat, locationLon } = el
      if (locationLat && locationLon) {
        mo.push([locationLat, locationLon])
        const marker = L.marker([locationLat, locationLon], {
          icon: new L.divIcon({
            iconSize: [48, 48],
            className: 'ws_map_tenant',
            iconAnchor: [5, 48],
          }),
        }).addTo(map)

        const html = getPopupHtml(el)
        const popup = new L.popup({
          offset: L.point(14, -41),
        }).setContent(html)

        marker.bindPopup(popup)

        marker.off('click')
        marker.on('click', (e: any) => {
          marker.openPopup()
        })
      }
      return mo
    }, [])
  }
}

const getPopupHtml = (info: any) => {
  const { orgName, deviceTotal, packageName, address } = info
  return `
      <div class='ws_mb4'>${'租户名称'}：${orgName}</div> 
      <div class='ws_mb4'>${'租户地址'}：${address}</div> 
      <div class='ws_mb4'>${'套餐类型'}：${packageName}</div> 
      <div class='ws_mb4'>${'设备数量'}：${deviceTotal}</div> 

    `
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})